angular.module('iqxCore')
.controller('PayslipsCtrl', function ($scope, FormSvc, ApiSvc, IQXPDFSvc) {
  $scope.checkPermissions('CANDIDATE')
  
  FormSvc.setOptions($scope,{
    fetchAPI:'callresult/NETITSPayslips',
    fetchTarget:'PaySlips',
    fetchWithPersonID: true,
    multiRow:true
  })

  $scope.fetch()

  $scope.PDFify = function () {
    IQXPDFSvc.PDF(
      'PDFpayslip',
      $scope.userName() + "_payslip_" + Date.now(),
      'download'
    )
  }

  $scope.viewPaySlip=function(PaySlip){
    return ApiSvc.fetch($scope,{fetchAPI:'callresult/NETITSPayslipsHours?importID='+PaySlip.ITSPayslipImportID, fetchTarget:'payslipHours',multiRow:true})
    .then(function(){
      return ApiSvc.fetch($scope,{fetchAPI:'callresult/NETITSPayslipHolidayPay?importID='+PaySlip.ITSPayslipImportID, fetchTarget:'payslipholidayPay',multiRow:true})
      .then(function(){
        return ApiSvc.fetch($scope,{fetchAPI:'callresult/NETITSPayslipsDeductions?importID='+PaySlip.ITSPayslipImportID, fetchTarget:'payslipDeductions',multiRow:true})
      })
    })
    .then(function(){
      PaySlip.hours = $scope.payslipHours
      PaySlip.holidaypay = $scope.payslipholidayPay
      PaySlip.deductions = $scope.payslipDeductions

      // Modal Form
      var choices=[{desc:'Download',type:'success',code:'download'},{desc:'Close',type:'primary',code:''}]
      var data={
        PaySlip:PaySlip, 
        choices:choices
      }
      $scope.data = data
      return FormSvc.modalInfo($scope,'viewPaySlip',data, 'lg')
      .then(function(rtrnData){
        if (rtrnData=="download") {
          document.getElementById('PDFpayslip').scrollIntoView()
          $scope.PDFify()
        }
      })
    })
  }
})
